import { render, staticRenderFns } from "./webSocket.vue?vue&type=template&id=5479f3e7&"
import script from "./webSocket.vue?vue&type=script&lang=js&"
export * from "./webSocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports